import(/* webpackMode: "eager", webpackExports: ["GenericPage"] */ "/vercel/path0/apps/frontend/src/app/[locale]/[...slug]/pages/GenericPage.js");
;
import(/* webpackMode: "eager", webpackExports: ["DossierListBlock"] */ "/vercel/path0/apps/frontend/src/components/editora/components/DossierListBlock.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageCourseInfoBlock"] */ "/vercel/path0/apps/frontend/src/components/editora/components/LanguageCourseInfoBlock.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableCartBlock"] */ "/vercel/path0/apps/frontend/src/components/editora/components/TableCartBlock.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/components/editora/Instances.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutManager"] */ "/vercel/path0/apps/frontend/src/components/layout/LayoutManager.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/frontend/src/components/layout/Navigation.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["CourseList"] */ "/vercel/path0/apps/frontend/src/components/ui/data-display/course-list/CourseList.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["MailValidation"] */ "/vercel/path0/apps/frontend/src/components/ui/data-display/mail-validation/MailValidation.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormOnlineEnrollment"] */ "/vercel/path0/apps/frontend/src/components/ui/forms/form-online-enrollment/FormOnlineEnrollment.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["FormShop"] */ "/vercel/path0/apps/frontend/src/components/ui/forms/form-shop/FormShop.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.8.2_next@15.5.12_react-dom@19.2.4_react@19.2.4__react@19.2.4__react@19.2.4_typescript@5.9.3/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.12_react-dom@19.2.4_react@19.2.4__react@19.2.4/node_modules/next/dist/client/app-dir/link.js");
